import { core_backend_url } from "../../config"

export const notapApi = {
    'updateWHTRates': `${core_backend_url}certificate/update-certificate-wht-rate`,
    'getWHTRates': `${core_backend_url}certificate/certificate-wht-rates`,
    'notapChangeStatus': `${core_backend_url}certificate/disbursement/approval/notap`,
    'getEvaluationHistory': `${core_backend_url}certificate/get-evaluations`,
    'getLetterHistory': (id)=>`${core_backend_url}digital-letters/letter/histories/${id}`,
    'getStaff': `${core_backend_url}certificate/notap/staff`,
    'submitEvaluation': `${core_backend_url}certificate/evaluation/notap`,
    // 'getCertificates' : `${core_backend_url}certificate/certificates`,
    // 'searchCertificates' : `${core_backend_url}certificate/search`,
    // 'currencies' : `${core_backend_url}certificate/currencies`,
    // 'uploadCertificate' : `${core_backend_url}certificate/upload`,
    // 'getComments' : (certificate_id) =>`${core_backend_url}certificate/${certificate_id}/comments`,
    // 'addComment' : `${core_backend_url}certificate/add-comment`,
    // 'getInboxLetters': `${core_backend_url}digital-letters/inbox`,
    // 'getSentLetters': `${core_backend_url}digital-letters/sent`,
    // 'getDraftLetters': `${core_backend_url}digital-letters/draft`,
    // 'sendLetter': `${core_backend_url}digital-letters/send`,
    // 'getUsers': `${core_backend_url}digital-letters/users`,
    // 'readLetter': (id) => `${core_backend_url}digital-letters/inbox/opened/${id}`,
    // 'deleteLetter': (id) => `${core_backend_url}digital-letters/inbox/delete/${id}`,
    // 'changeStatus': `${core_backend_url}certificate/change-status`
}